import React, { Component } from 'react';
import _ from 'lodash';
import { StyledFormLabel, StyledModal } from '../style';
import {
  StyledAlignRight,
  StyledList,
  StyledRepeatedElements,
  StyledBox,
  TitleButton,
  StyledDateSelector,
  StyledDateContainer,
  StyledFormBottom,
  StyledFormLeyend,
  StyledLeyendNum,
  StyledLeyendText,
  StyledForm,
  StyleInput,
  StyledDropdownInput,
  StyledTwoLevelBreadcrumb,
  StyledFormWrapper
} from './style';

import { IRPFData } from '.';

import { IRPFDataTxts, AscendantsTxts } from '../../../../../constants/irpf';

import { convertDateToBBDDFormat } from '../../../../../utils/dates';
import {
  checkValid,
  isFormValid,
  getGenderLabelFromLetter
} from '../../../../../utils/irpfData';

import Button from '../../../../core/Buttons';

import { FormColumns, FormColumn } from '../index';

// Para inicializar un ascendiente o descendiente

const validParentObj = {
  birthDate: true,
  name: true,
  related: 'ASCENDANT',
  surname1: true,
  surname2: true,
  gender: true
};

class ParentsForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      parent: this.props.initialData
        ? _.cloneDeep(this.props.initialData)
        : {
            birthDate: null,
            coexistenceOthersDescendants: null,
            deathChild: null,
            endDate: null,
            gender: null,
            name: null,
            related: 'ASCENDANT',
            surname1: null,
            surname2: null
          },
      validParent: validParentObj,
      isCancelling: false,
      disabledBtn: props.editMode
    };
  }

  // Compruebo que todo está correcto antes de enviar los datos
  handleOnSend = () => {
    const {
      editMode,
      onSend,
      lastFamilyNumber,
      currentFamilyNumber
    } = this.props;
    const { parent } = this.state;
    const newValidParent = {
      name: checkValid(parent.name, 0),
      birthDate: parent.birthDate !== null,
      surname1: checkValid(parent.surname1, 0),
      gender: parent.gender !== null
    };

    this.setState({
      validParent: newValidParent
    });

    if (isFormValid(newValidParent) && onSend) {
      const newParent = _.cloneDeep(parent);
      const newParentFormatted = Object.entries(newParent).reduce(
        (acc, next) => {
          const [key, value] = next;
          if (value) {
            acc[key] = value;
          }
          return acc;
        },
        {}
      );

      newParentFormatted.familyNumber = editMode
        ? currentFamilyNumber
        : lastFamilyNumber + 1;

      onSend(newParentFormatted, editMode);
    }
  };

  handleCancel = (state = true) => {
    this.setState({
      isCancelling: state
    });
  };

  changeParents = (value, key) => {
    const { initialData } = this.props;
    const { parent, validParent } = this.state;
    const valueUpdated =
      key.includes('Date') && value ? convertDateToBBDDFormat(value) : value;

    parent[key] = valueUpdated;
    validParent[key] = true;

    if (!value && !('coexistenceOthersDescendants' in initialData)) {
      delete parent[key];
    }

    const dataHasNotChanged = _.isEqual(initialData, parent);

    this.setState({
      parent,
      validParent,
      disabledBtn: dataHasNotChanged
    });
  };

  render() {
    const { parent, validParent, isCancelling, disabledBtn } = this.state;

    return (
      <IRPFData>
        <StyledFormWrapper>
          <StyledTwoLevelBreadcrumb
            first={IRPFDataTxts.breadcrumb.first}
            second={IRPFDataTxts.breadcrumb.second}
            onBack={this.handleCancel}
          />
          <StyledBox>
            <TitleButton>{AscendantsTxts.titleButton}</TitleButton>
            <StyledList>
              <StyledRepeatedElements>
                <StyledForm>
                  <FormColumns className="fullColumn">
                    <StyledDateContainer>
                      <StyledFormLabel htmlFor="parent_fNacimiento">
                        Fecha nacimiento *
                      </StyledFormLabel>
                      <StyledDateSelector
                        onChange={value =>
                          this.changeParents(value, 'birthDate')
                        }
                        years={100}
                        date={parent.birthDate}
                        error={!validParent.birthDate}
                      />
                    </StyledDateContainer>
                    <StyledDateContainer className="endDate">
                      <StyledFormLabel>Fecha finalización</StyledFormLabel>
                      <StyledDateSelector
                        onChange={value => this.changeParents(value, 'endDate')}
                        years={50}
                        date={parent.endDate}
                      />
                    </StyledDateContainer>
                    <FormColumn>
                      <StyledFormLabel htmlFor="parent_nombre">
                        Nombre *
                      </StyledFormLabel>
                      <StyleInput
                        id="parent_nombre"
                        name="parent_nombre"
                        value={parent.name}
                        onChange={value => this.changeParents(value, 'name')}
                        error={
                          !validParent.name ? 'Introduzca un nombre' : false
                        }
                      />
                    </FormColumn>
                    <FormColumn>
                      <StyledFormLabel htmlFor="parent_apellido1">
                        1er Apellido *
                      </StyledFormLabel>
                      <StyleInput
                        id="parent_apellido1"
                        name="parent_apellido1"
                        value={parent.surname1}
                        error={
                          !validParent.surname1
                            ? 'Introduzca el primer apellido'
                            : false
                        }
                        onChange={value =>
                          this.changeParents(value, 'surname1')
                        }
                      />
                    </FormColumn>
                    <FormColumn>
                      <StyledFormLabel htmlFor="parent_apellido2">
                        2º Apellido
                      </StyledFormLabel>
                      <StyleInput
                        id="parent_apellido2"
                        name="parent_apellido2"
                        value={parent.surname2}
                        onChange={value =>
                          this.changeParents(value, 'surname2')
                        }
                      />
                    </FormColumn>
                    <FormColumn>
                      <StyledFormLabel htmlFor="parent_sexo">
                        Sexo *
                      </StyledFormLabel>
                      <StyledDropdownInput
                        list={[
                          { value: 'H', text: 'Hombre' },
                          { value: 'M', text: 'Mujer' }
                        ]}
                        label={getGenderLabelFromLetter(parent.gender)}
                        value={parent.gender}
                        onSelect={gender =>
                          this.changeParents(gender.value, 'gender')
                        }
                        error={!validParent.gender}
                        small
                      />
                    </FormColumn>
                    <FormColumn>
                      <StyledFormLabel htmlFor="parent_convivencia">
                        Convivencia con otros descendientes (*1)
                      </StyledFormLabel>
                      <StyleInput
                        id="parent_convivencia"
                        name="parent_convivencia"
                        value={parent.coexistenceOthersDescendants}
                        onChange={value =>
                          this.changeParents(
                            value,
                            'coexistenceOthersDescendants'
                          )
                        }
                      />
                    </FormColumn>
                  </FormColumns>
                  <StyledFormBottom>
                    <StyledFormLeyend>
                      <StyledLeyendText>
                        <StyledLeyendNum>(*1)</StyledLeyendNum>
                        {` `}
                        {AscendantsTxts.legend}
                      </StyledLeyendText>
                    </StyledFormLeyend>
                  </StyledFormBottom>
                </StyledForm>
              </StyledRepeatedElements>
            </StyledList>
          </StyledBox>
          <StyledAlignRight>
            <Button dark ghost onClick={this.handleCancel}>
              CANCELAR
            </Button>
            <Button
              secondary
              onClick={() => this.handleOnSend()}
              disabled={this.props.editMode && disabledBtn}
            >
              ENVIAR SOLICITUD
            </Button>
          </StyledAlignRight>
          {isCancelling && (
            <StyledModal
              title="CANCELAR SOLICITUD"
              clickCloseIcon={() => this.handleCancel(false)}
            >
              <p>¿Seguro que quieres cancelar la solicitud?</p>
              <Button modal onClick={() => this.handleCancel(false)}>
                Seguir editando
              </Button>
              <Button secondary onClick={this.props.onCancel}>
                Cancelar
              </Button>
            </StyledModal>
          )}
        </StyledFormWrapper>
      </IRPFData>
    );
  }
}

export { ParentsForm };
